import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import _ from 'lodash';
import Button from '../../common/components/Button';
import CopyHtml from '../../common/components/CopyHtml';
import { getCopy } from '../../common/lib/copyDefaults';
import { maskEmail } from '../../common/lib/maskEmail';
import { buildLoginPath } from '../../common/lib/redirectToLogin';

import '../../../style/index.css';
import './userDuplicated.css';

const mapStateToProps = (state) => ({ duplicatedEmail: state.registerReducer.duplicatedEmail });

class UserDuplicatedView extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    duplicatedEmail: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleResetPasswordClick = this.handleResetPasswordClick.bind(this);
  }

  componentDidMount() {
    requestAnimationFrame(() => {
      const el = document.getElementById('user-duplicated-heading');
      if (el) {
        el.focus();
      }
    });
  }

  handleLoginClick() {
    this.props.history.push(buildLoginPath());
  }

  handleResetPasswordClick() {
    const queryParams = queryString.parse(window.location.search);
    const clientId = _.get(queryParams, 'clientId', false);
    this.props.history.push(`/reset-password?clientId=${clientId}`);
  }

  render() {
    const copy = getCopy('/user-duplicated');
    const { phone, email } = __CONFIG__.contact;
    const { duplicatedEmail } = this.props;
    const maskedEmail = maskEmail(duplicatedEmail);
    const supportHtml = copy.support.replace('{phone}', phone).replace(/{email}/g, email);

    return (
      <div className="user-duplicated row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <div className="user-duplicated__body">
            <h1 id="user-duplicated-heading" tabIndex={-1} className="user-duplicated__title">
              {copy.header}
            </h1>
            <p className="user-duplicated__description">{copy.intro}</p>
            <p className="user-duplicated__email">
              <strong>{maskedEmail}</strong>
            </p>
            <p className="user-duplicated__description">{copy.instructions}</p>
            <CopyHtml html={supportHtml} className="user-duplicated__support" />
          </div>
          <div className="button-wrap">
            <Button
              label={copy.loginButtonLabel}
              onClickFn={this.handleLoginClick}
              className="nyl-button"
              id="user-duplicated-login-button"
            />
            <Button
              label={copy.resetPasswordButtonLabel}
              onClickFn={this.handleResetPasswordClick}
              className="nyl-button nyl-button--secondary"
              id="user-duplicated-reset-password-button"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, null)(UserDuplicatedView));
